import { Module, VuexModule, Action, Mutation } from "vuex-class-modules";
import QuizzService from "@/services/quizz.service";

@Module
export class Quizz extends VuexModule {
  private _quizzs = null;

  @Mutation
  private setQuizzs(quizzs: any): any {
    this._quizzs = quizzs;
  }

  @Action
  public async quizzs(): Promise<void> {
    const quizzs = await await QuizzService.quizzs();
    this.setQuizzs(quizzs);
  }

  get getQuizzs(): any {
    return this._quizzs;
  }
}
